/**
 * Utility class for free locality feature
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import store, { JobStore } from '../../../store';
import { PACKS } from '../packHandler';
import { copyObject } from '../../../utils';
import { POST_AD_FIELDS, PAP_CONSTANTS } from '../index';
import JobsPostAdRequest from '../../../utils/JobsPostAd/jobsPostAdRequest';

export default class FreeLocality {

    static creditForExtraLocality = (localityCount, store) => {
        return parseInt(Math.ceil((localityCount * store.config.papPrices.creditToDeductBasePrice * store.config.papPrices.creditToDeductBaseLocality) - 1), 10);
    };

    static getLineItem = (store) => {
        let type = 'money';
        let localitiesSelected = store.postAdRequest[POST_AD_FIELDS.LOCALITY].value;
        let localityCount = localitiesSelected.length;
        let display = localityCount + ' Localities Selected (' + PAP_CONSTANTS.MAX_FREE_LOCALITY + ' Free)';
        let value = 0;

        if (store.config.papPrices && localityCount > 0 && PACKS.GOLD === store.postAdRequest.others.selectedPack && store.user.hasCredits) {
            // Credit calculation for extra locality
            value = FreeLocality.creditForExtraLocality(localityCount, store);
        }

      if (1 === localityCount && store.config.papPrices && localitiesSelected[0].indexOf(PAP_CONSTANTS.FULL_CITY) >= 0) {
        display = PAP_CONSTANTS.FULL_CITY;
        value = store.config.papPrices.creditToDeductFullCity;
        type =  'credit';
      }
    	else if (store.user.credits > 0 && PACKS.GOLD === store.postAdRequest.others.selectedPack)
    		type =  'credit';

    	return { display, value, type };
    };

    // Get credit to deduct for gold ad + full city + locality
    static getCreditToDeduct = _ => {
        let jobStore = store.getState().jobs;
        let value = 0;
        
        if ( PACKS.GOLD === jobStore.postAdRequest.others.selectedPack ) {
            // one credit for gold ad
            value++;

            let localitiesSelected = jobStore.postAdRequest[POST_AD_FIELDS.LOCALITY].value;
            let localityCount = localitiesSelected.length;

            if (1 === localityCount && jobStore.config.papPrices && localitiesSelected[0].indexOf(PAP_CONSTANTS.FULL_CITY) >= 0) {
                // adding credit for full city
                value = value + parseInt(jobStore.config.papPrices.creditToDeductFullCity, 10);
            }
            else if (jobStore.config.papPrices && localityCount > 0 && jobStore.user.hasCredits) {
                // adding credit for extra localities
                value = value + FreeLocality.creditForExtraLocality(localityCount, jobStore);
            }
        }

        return value;
    };

    static getCustomLocalityLineItems = _ => {
        let jobstore = store.getState().jobs;
        let fullCity = jobstore.postAdRequest[POST_AD_FIELDS.LOCALITY].fullCity;

        return [ { value: fullCity.display, show: fullCity.show, data1: PAP_CONSTANTS.FULL_CITY }];
    };

    static showFullCity = _ => {
        let jobstore = store.getState().jobs;
        let fullCity = jobstore.postAdRequest[POST_AD_FIELDS.LOCALITY].fullCity;

        return fullCity.show;
    };

    static setFullCityDetails = _ => {
        let jobstore = store.getState().jobs;
        let papPrices = jobstore.config.papPrices;
        let updatedRequest = copyObject(jobstore.postAdRequest);

        if (papPrices && papPrices.creditToDeductFullCity && papPrices.full_city_conditions) {
            let condition = JSON.parse(papPrices.full_city_conditions);

            let display = 'Full City ' + papPrices.creditToDeductFullCity + ' Credits ';
            let localityObject = updatedRequest[POST_AD_FIELDS.LOCALITY];
            localityObject.fullCity.display = display;
            localityObject.fullCity.show = condition.display_full_city && jobstore.user.hasCredits;

            let newPayload = {
                [POST_AD_FIELDS.LOCALITY]: localityObject
            };
            JobsPostAdRequest.updatePostAdRequest(newPayload);
        }
    };

    static setLocalityMaxSelectionLimit = _ => {
        let jobstore = JobStore.getState();
        let updatedRequest = copyObject(jobstore.postAdRequest);

        if (jobstore.user.hasCredits) {
            let localityObject = updatedRequest[POST_AD_FIELDS.LOCALITY];
            localityObject.maxLimit = 999;
            let newPayload = {
                [POST_AD_FIELDS.LOCALITY]: localityObject
            };
            JobsPostAdRequest.updatePostAdRequest(newPayload);
        }
    };
}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/JobsPostAd/others/freeLocality.js